import { render, staticRenderFns } from "./past_achievements.schema.vue?vue&type=template&id=2dcfc0ae&"
import script from "./past_achievements.schema.vue?vue&type=script&lang=js&"
export * from "./past_achievements.schema.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports